/**
 * Scheduling-local email validation. Wraps the shared `validateEmail()` with
 * an additional local-part allowlist so bookers can't submit an email whose
 * local part contains an RFC-valid-but-typo character (e.g. a backtick).
 */

import { validateEmail } from '@/lib/auth/constants';

// Mirrors the backend guard in apps/scheduling/utils.py validate_email(). Rejects local
// parts with RFC-valid-but-typo characters (e.g. a backtick). Apostrophe kept for o'brien@.
const BOOKING_EMAIL_LOCAL_PART = /^[A-Za-z0-9._%+'-]+$/;

export function validateBookingEmail(value: unknown): string | undefined {
  const base = validateEmail(value);
  if (base) {
    return base;
  }
  const s = typeof value === 'string' ? value.trim() : '';
  if (!s) {
    return undefined;
  }
  const atIndex = s.lastIndexOf('@');
  const localPart = atIndex === -1 ? s : s.slice(0, atIndex);
  if (!BOOKING_EMAIL_LOCAL_PART.test(localPart)) {
    return 'Please enter a valid email address';
  }
  return undefined;
}
